<div class="content-container">
  <div class="content-area">
    <div class="text-center" style="display: flex; align-items: center;justify-content: center;height:100vh">
      <h1>CorHealth Registration Application Coming Soon</h1>
    </div>
  </div>
</div>
